const url = window.location.href.toLowerCase();
const origin = window.location.origin.toLowerCase();

const dev = {
    environment: 'nick-dev',
    useAxe: false,
    apiGateway: {
        CODE: '',
        LESSONLY: '',
        URL: 'http://localhost:7071/api/',
        JOB_URL: 'http://localhost:7072/api/',
    },
    azure: {
        clientId: '4915f4bd-b49f-445f-a81f-a01a25fcdafb', //This is your client ID
        authority: 'https://login.microsoftonline.com/common', //This is your tenant info
    },
    hubspot: {
        auth: 'https://app.hubspot.com/oauth/authorize?client_id=b21b5f1e-5bb8-4198-9a21-a59de1996517&redirect_uri=https://localhost:3000/oauth/hubspot&scope=crm.lists.read%20crm.objects.contacts.read%20crm.schemas.contacts.read%20crm.objects.companies.read%20crm.objects.deals.read%20crm.schemas.companies.read%20crm.schemas.deals.read%20settings.users.read',
    },
    posthog: { key: 'phc_sYJzaIlwLcNDq5mM3rB661UQfLdNeGox0QuHoSL2gcm', survey: '01928bcc-06b8-0000-a482-96356af0a1af' },
    switches: {},
    url: url.indexOf('nick.dev') >= 0 ? 'https://nick.dev.local.com:3000/' : 'https://localhost:3000/',
    supportEmail: 'nick.lewis+insightssupport@richardson.com',
};

const demo = {
    environment: 'demo',
    apiGateway: {
        CODE: 'oRv2TCiwonVPZloqliaqf3mzkOu0sMT2---CziiqctwdAzFu8lGFPg==',
        LESSONLY: 'DnYwfIWnAbiiC-Xomim1BsO9wDcpX_dfOFmBU3XZNHusAzFuEwqp8w==',
        URL: 'https://insights-api-demo.richardsonaccelerate.com/api/',
        JOB_URL: 'https://insights-timers-demo.richardsonaccelerate.com/api/',
    },
    azure: {
        clientId: 'b34ef8fe-558c-478f-9782-38c6921d42fc', //This is your client ID
        authority: 'https://login.microsoftonline.com/common', //This is your tenant info
    },
    hubspot: {
        auth: 'https://app.hubspot.com/oauth/authorize?client_id=b21b5f1e-5bb8-4198-9a21-a59de1996517&redirect_uri=https://insights-demo.richardsonaccelerate.com/oauth/hubspot&scope=crm.lists.read%20crm.objects.contacts.read%20crm.schemas.contacts.read%20crm.objects.companies.read%20crm.objects.deals.read%20crm.schemas.companies.read%20crm.schemas.deals.read%20settings.users.read',
    },
    posthog: { key: 'phc_sYJzaIlwLcNDq5mM3rB661UQfLdNeGox0QuHoSL2gcm', survey: '01928bcc-06b8-0000-a482-96356af0a1af' },
    switches: {
        languages: true,
    },
    url: 'https://insights-demo.richardsonaccelerate.com/',
};

const preview = {
    environment: 'preview',
    apiGateway: {
        CODE: '1SqM7QgWVoaAdzwk0fOp6YY4YUGu6RiEIBs6Qur2-r90AzFuHIGM7w==',
        LESSONLY: 'Xs1AHfExAfcnDpuwTkUZQHwlMA0kVQqHcRJA1T2AYvruAzFuKnKbMQ==',
        URL: 'https://insights-api-preview.richardsonaccelerate.com/api/',
        JOB_URL: 'https://insights-timers-preview.richardsonaccelerate.com/api/',
    },
    azure: {
        clientId: 'd2fd24b7-0e80-4eb4-b851-2e8eb200811b', //This is your client ID
        authority: 'https://login.microsoftonline.com/common', //This is your tenant info
    },
    hubspot: {
        auth: 'https://app.hubspot.com/oauth/authorize?client_id=b21b5f1e-5bb8-4198-9a21-a59de1996517&redirect_uri=https://insights-preview.richardsonaccelerate.com/oauth/hubspot&scope=crm.lists.read%20crm.objects.contacts.read%20crm.schemas.contacts.read%20crm.objects.companies.read%20crm.objects.deals.read%20crm.schemas.companies.read%20crm.schemas.deals.read%20settings.users.read',
    },
    posthog: { key: 'phc_sYJzaIlwLcNDq5mM3rB661UQfLdNeGox0QuHoSL2gcm', survey: '01928bcc-06b8-0000-a482-96356af0a1af' },
    switches: {
        languages: true,
    },
    url: 'https://insights-preview.richardsonaccelerate.com/',
};

const prod = {
    environment: 'live',
    useAxe: false,
    apiGateway: {
        CODE: 'yUgQqScsTt-xpdytEb1GS1GaUQYbWqmhIjMb3VMEKbITAzFu6LdB-Q==',
        LESSONLY: 'LCHyDIW6a5jZET0CgxJ2yTN82-FRryPoaMzUzo-c0-9UAzFu9VeUxA==',
        URL: 'https://insights-api-live.richardsonaccelerate.com/api/',
        JOB_URL: 'https://insights-timers-live.richardsonaccelerate.com/api/',
    },
    azure: {
        clientId: 'aac86c74-0969-4ca7-920a-401c892e8b85', //This is your client ID
        authority: 'https://login.microsoftonline.com/common', //This is your tenant info
    },
    hubspot: {
        auth: 'https://app.hubspot.com/oauth/authorize?client_id=b21b5f1e-5bb8-4198-9a21-a59de1996517&redirect_uri=https://insights.richardsonaccelerate.com/oauth/hubspot&scope=crm.lists.read%20crm.objects.contacts.read%20crm.schemas.contacts.read%20crm.objects.companies.read%20crm.objects.deals.read%20crm.schemas.companies.read%20crm.schemas.deals.read%20settings.users.read',
    },
    honeybadger: { key: 'hbp_MzPef38LdkNC9yPyJR5lXdOIj9JBK13PXI9e', environment: 'production' },
    posthog: { key: 'phc_qMZ32iqWjRqT5Icitr4VPiSyxrRqCB1OPMstmiN54va', survey: '0192dd7e-f834-0000-2fbe-bd4be4f100fc' },
    switches: {
        languages: false,
    },
    url: 'https://insights.richardsonaccelerate.com/',
};

const qa = {
    environment: 'qa',
    apiGateway: {
        CODE: '1SqM7QgWVoaAdzwk0fOp6YY4YUGu6RiEIBs6Qur2-r90AzFuHIGM7w==',
        LESSONLY: 'Xs1AHfExAfcnDpuwTkUZQHwlMA0kVQqHcRJA1T2AYvruAzFuKnKbMQ==',
        URL:  origin + '/api/', 
        //JOB_URL: 'https://insights-timers-preview.richardsonaccelerate.com/api/', 
        JOB_URL: origin + '/jobs/'
    },
    azure: {
        clientId: 'd2fd24b7-0e80-4eb4-b851-2e8eb200811b', //This is your client ID
        authority: 'https://login.microsoftonline.com/common', //This is your tenant info
    },
    hubspot: {
        auth: 'https://app.hubspot.com/oauth/authorize?client_id=b21b5f1e-5bb8-4198-9a21-a59de1996517&redirect_uri=https://insights-preview.richardsonaccelerate.com/oauth/hubspot&scope=crm.lists.read%20crm.objects.contacts.read%20crm.schemas.contacts.read%20crm.objects.companies.read%20crm.objects.deals.read%20crm.schemas.companies.read%20crm.schemas.deals.read%20settings.users.read',
    },
    posthog: { key: 'phc_sYJzaIlwLcNDq5mM3rB661UQfLdNeGox0QuHoSL2gcm', survey: '01928bcc-06b8-0000-a482-96356af0a1af' },
    switches: {
        languages: true,
    },

    url: origin + '/'
};

const isLive = url.indexOf('insights.richardsonaccelerate.com') >= 0;
const isPreview = url.indexOf('insights-preview.richardsonaccelerate.com') >= 0;
const isQA = url.indexOf('.qa.richardsonaccelerate.com') >= 0;

let env = '';
try {
    env = process?.env.NODE_ENV || '';
} catch {
    env = '';
}

let config = env === 'production' ? (isLive ? prod : isPreview ? preview : demo) : dev;

// If url site contains .qa.richardsonaccelerate.com then set active config to QA config section
if(isQA) {
 config = qa;
}


export default {
    MAX_ATTACHMENT_SIZE: 10485760, // 10 MB
    MAX_VIDEO_SIZE: 524288000, // 500 MB
    mediaExtensions: ['.m4a', '.m4v', '.mov', '.mp3', '.mp4', '.ogg', '.webm', '.wmv'],
    useAxe: true,
    storage: {
        URL: 'https://insightsmedia.richardsonaccelerate.com/',
        ScormWrapper: 'scorm/scorm-wrapper-999.html',
    },
    hubspot: {
        auth: 'https://app.hubspot.com/oauth/authorize?client_id=b21b5f1e-5bb8-4198-9a21-a59de1996517&redirect_uri=https://insights.richardsonaccelerate.com/oauth/hubspot&scope=crm.lists.read%20crm.objects.contacts.read%20crm.schemas.contacts.read%20crm.objects.companies.read%20crm.objects.deals.read%20crm.schemas.companies.read%20crm.schemas.deals.read%20settings.users.read',
    },
    outreach: {
        applicationId: '15HLnKe3ZYVY3cz35VPUuO09FT__8BqpBrqb-urhewg',
        scopes: 'calls.read+mailings.read+users.read+callDispositions.read+tasks.read',
        auth: 'https://api.outreach.io/oauth/authorize?client_id=<Application_Identifier>&redirect_uri=<Redirect_Uri>&response_type=code&scope=<Scopes>',
    },
    salesforce: {
        clientId: '3MVG9L8AofS.N0y68nzO2PJwzCY8kLjSfFKQSLmxEbak70IkVWfWom7GQZtTMIw9_72rtJIXrLGdHUFjmwBOU',
    },
    showpad: {
        auth: 'https://<Subdomain>.showpad.biz/api/v3/oauth2/authorize?client_id=<Client_Id>&redirect_uri=<Redirect_Uri>&response_type=code',
    },
    honeybadger: { key: 'hbp_MzPef38LdkNC9yPyJR5lXdOIj9JBK13PXI9e', environment: 'development' },
    google: {
        clientId: '151135267675-k0d1vsntkpf64t2n53argbn425f3lukg.apps.googleusercontent.com',
        key: 'AIzaSyAJ9XglxoFZic-BS5ZzbkSAZHCbLPFzg-s',
        shareKey: 'AIzaSyBMRfxSnjskCX61J4FugyJ2-brMmbmfJiA',
        project: '151135267675',
        scope: ['https://www.googleapis.com/auth/drive', 'https://www.googleapis.com/auth/youtube.readonly'],
    },
    supportEmail: 'support@richardson.com',
    supportUrl: 'https://support.richardson.com/hc/en-us/requests/new',
    ...config,
};
